import { render, staticRenderFns } from "./AdminBar.vue?vue&type=template&id=eca56e08&scoped=true"
import script from "./AdminBar.vue?vue&type=script&lang=js"
export * from "./AdminBar.vue?vue&type=script&lang=js"
import style0 from "./AdminBar.vue?vue&type=style&index=0&id=eca56e08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca56e08",
  null
  
)

export default component.exports